import { render, staticRenderFns } from "./title.vue?vue&type=template&id=3eaa3922&scoped=true&"
import script from "./title.vue?vue&type=script&lang=js&"
export * from "./title.vue?vue&type=script&lang=js&"
import style0 from "./title.vue?vue&type=style&index=0&id=3eaa3922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eaa3922",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3eaa3922')) {
      api.createRecord('3eaa3922', component.options)
    } else {
      api.reload('3eaa3922', component.options)
    }
    module.hot.accept("./title.vue?vue&type=template&id=3eaa3922&scoped=true&", function () {
      api.rerender('3eaa3922', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/wallet/fullNode/title.vue"
export default component.exports